import zipObject from 'lodash/zipObject';
import { getComputedColor } from '@/utils/color.js';
import { PendoColorNamesMap } from '@/constants/color-strings.js';

// COLORS
export const colorClasses = [
    '.groupColor01',
    '.groupColor02',
    '.groupColor03',
    '.groupColor04',
    '.groupColor05',
    '.groupColor06',
    '.groupColor07',
    '.groupColor08',
    '.groupColor09',
    '.groupColor10',
    '.groupColorUngrouped', // The "ungrouped" class must always be last
];

export const colors = [
    getComputedColor('var(--product-area-group-color-1)'),
    getComputedColor('var(--product-area-group-color-2)'),
    getComputedColor('var(--product-area-group-color-3)'),
    getComputedColor('var(--product-area-group-color-4)'),
    getComputedColor('var(--product-area-group-color-5)'),
    getComputedColor('var(--product-area-group-color-6)'),
    getComputedColor('var(--product-area-group-color-7)'),
    getComputedColor('var(--product-area-group-color-8)'),
    getComputedColor('var(--product-area-group-color-9)'),
    getComputedColor('var(--product-area-group-color-10)'),
    getComputedColor('var(--product-area-group-color-ungrouped)'), // The "ungrouped" color must always be last
];

// Preset labels for color picker aria labels. Excludes ungrouped.
export const colorLabelsMap = {
    [colors[0]]: PendoColorNamesMap.regular.pink,
    [colors[1]]: PendoColorNamesMap.regular.magenta,
    [colors[2]]: PendoColorNamesMap.regular.orange,
    [colors[3]]: PendoColorNamesMap.light.orange,
    [colors[4]]: PendoColorNamesMap.regular.teal,
    [colors[5]]: PendoColorNamesMap.regular.green,
    [colors[6]]: PendoColorNamesMap.dark.blue,
    [colors[7]]: PendoColorNamesMap.regular.blue,
    [colors[8]]: PendoColorNamesMap.dark.purple,
    [colors[9]]: PendoColorNamesMap.regular.purple,
};

export const colorMap = zipObject(colorClasses, colors);

export const colorClassMap = zipObject(colors, colorClasses);

export const defaultColorClass = colorClasses[0];

export const defaultColor = colors[0];
